import { useMemo } from "react";
import { useLocation, useParams } from "react-router-dom";
import { objectTypes } from "src/consts/objectTypes";
import { useProjectVariationById } from "./useProjectVariationById";
import { routes } from "src/routes";

export function useObjectType() {
  const { inspectionId, deviationId, companyId } = useParams();
  const location = useLocation();
  const { data: currentItem } = useProjectVariationById(
    inspectionId && deviationId ? deviationId : inspectionId ?? deviationId
  );
  const objectTypeItem = useMemo(() => {
    if (currentItem) {
      return { id: currentItem.id, objectType: currentItem.objectType };
    }
    if (
      location.pathname.startsWith(routes.Deviation.Pages.List.url(companyId!))
    ) {
      return { id: deviationId, objectType: objectTypes.Deviation };
    }
    if (
      location.pathname.startsWith(
        routes.Egenkontroller.Pages.List.url(companyId!)
      )
    ) {
      return { id: inspectionId, objectType: objectTypes.Inspection };
    }

    return { id: inspectionId, objectType: objectTypes.Inspection };
  }, [inspectionId, deviationId, location.pathname, companyId]);

  return objectTypeItem;
}
